import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { message } from 'antd';
import { FiPaperclip } from 'react-icons/fi';
import Anchor from '../../components/link/Anchor';
import { setDateFormat } from '../moment';
import { MAXIMUM_PERCENT } from '../../constants/service/common/commonConstants';
import { DATE_PICKER_DEFAULT_BUTTON_TEXT } from '../../constants/service/common/utilConstants';

/**
 *  path 의 여부에 따라서 Link 컴포넌트 분기
 *  path 가 있으면 Link 컴포넌트를
 *  path 가 없으면 Anchor 컴포넌트를 상용함
 */
export const setSidebarManItem = (path, icon, text) => {
  const Item = (
    <Fragment>
      {icon}
      <div className="text">{text}</div>
    </Fragment>
  );

  if (path) {
    return <Link to={path}>{Item}</Link>;
  } else return <Anchor text={Item} />;
};

/**
 *  선택된 날짜를 VIEW 에 노출하기 위한 텍스트 값을 설정
 */
export const setDateRangePickerBtnText = (btnTextFormat = 'LL', startDate, endDate) => {
  return startDate && endDate ? (
    <Fragment>
      <div>{setDateFormat(startDate, btnTextFormat)}</div>
      <span>~</span>
      <div>{setDateFormat(endDate, btnTextFormat)}</div>
    </Fragment>
  ) : (
    DATE_PICKER_DEFAULT_BUTTON_TEXT
  );
};

/**
 *  선택된 날짜를 VIEW 에 노출하기 위한 텍스트 값을 설정
 */
export const setDateSinglePickerBtnText = (btnTextFormat = 'LL', selectedDay) => {
  return selectedDay ? setDateFormat(selectedDay, btnTextFormat) : DATE_PICKER_DEFAULT_BUTTON_TEXT;
};

/**
 *  수수료 최대값 설정
 */
export const setFeeMaximumNumber = (list, maxNumber = MAXIMUM_PERCENT) => {
  const listNumber = list.reduce((acc, number) => acc + number, 0);
  return maxNumber - listNumber;
};

/**
 *  클립보드 복사
 */
export const setCopyToClipboardIcon = (value) => {
  return (
    <FiPaperclip
      style={{
        marginLeft: '10px',
        cursor: 'pointer',
      }}
      onClick={() => {
        navigator.clipboard.writeText(value);
        message.success('복사 성공');
      }}
    />
  );
};
